import React, { useRef, useState, useEffect } from 'react'
import ThayDoiPassBank from '../RutTien/ThayDoiPassBank/ThayDoiPassBank'
import { useUser } from '../../../../component/UserProvider/UserProvider'
import { getFromlocalstorage } from '../../../../component/MaHoaDuLieu/MaHoaDuLieu'
import Notify from '../../../../component/Notify/Notify'
import Loading from '../../../../component/Loading/Loading'

const PersonalTabs = () => {
  const [activeTab, setActiveTab] = useState('messages')
  const hasFetched = useRef(false)
  const data_user = JSON.parse(getFromlocalstorage("data_u"))
  const { user, fetchUser } = useUser()

  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [typenoti, setTypenoti] = useState('error')

  const apiUrl = process.env.REACT_APP_API_BACKEND

  useEffect(() => {
    if (data_user && !hasFetched.current) {
      fetchUser(data_user._id)
      hasFetched.current = true
    }
  }, [data_user])

  const handleChangePassword = async (e) => {
    e.preventDefault()

    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage('กรุณากรอกข้อมูลให้ครบถ้วน')
      setTypenoti('error')
      return
    }

    if (newPassword !== confirmPassword) {
      setMessage('รหัสผ่านยืนยันไม่ตรงกัน')
      setTypenoti('error')
      return
    }

    setLoading(true)

    try {
      const res = await fetch(`${apiUrl}/postrepass/${data_user._id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          password_old: oldPassword,
          password: newPassword
        })
      })

      const result = await res.json()

      if (res.ok) {
        setMessage('อัปเดตรหัสผ่านสำเร็จ')
        setTypenoti('success')

        setOldPassword('')
        setNewPassword('')
        setConfirmPassword('')
      } else {
        setMessage(result.message || 'อัปเดตไม่สำเร็จ')
        setTypenoti('error')
      }
    } catch (error) {
      setMessage('เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน')
      setTypenoti('error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='tabs-header'>
        <div className='tabs'>
          <button
            className={`tab ${activeTab === 'messages' ? 'active' : ''}`}
            onClick={() => setActiveTab('messages')}
          >
            ข้อความของฉัน
          </button>

          <button
            className={`tab ${
              activeTab === 'change-login-password' ? 'active' : ''
            }`}
            onClick={() => setActiveTab('change-login-password')}
          >
            เปลี่ยนรหัสผ่านเข้าสู่ระบบ
          </button>

          <button
            className={`tab ${
              activeTab === 'change-withdraw-password' ? 'active' : ''
            }`}
            onClick={() => setActiveTab('change-withdraw-password')}
          >
            เปลี่ยนรหัสผ่านถอนเงิน
          </button>
        </div>

        <button className='clear-cache'>
          <i className='fas fa-trash-alt' />
          <span>ล้างแคช</span>
        </button>
      </div>

      <section className='user-info'>
        <div className='info'>
          <img
            src='https://storage.googleapis.com/a1aa/image/41cd23ab-15a0-4b10-c2d4-fd6e7e838dd6.jpg'
            alt='User avatar'
          />

          <div className='text'>
            <p className='greeting'>
              ราตรีสวัสดิ์,{' '}
              <span className='highlight'>te***00</span>
              <span className='label'>ทั่วไป</span>
            </p>

            <p className='greeting1'>
              <span className='bold'>บัญชี:</span>
              <a href='#'>{user?.username}</a>
            </p>

            <p className='greeting1'>
              <span className='bold'>หมายเลขโทรศัพท์:</span>
              <a href='#'>{user?.phone}</a>
            </p>
          </div>
        </div>

        <button className='personal-info-btn'>
          ข้อมูลส่วนตัว
        </button>
      </section>

      <div className='tab-content'>
        {activeTab === 'change-login-password' && (
          <div className='change-password'>
            <form
              className='form'
              onSubmit={handleChangePassword}
            >
              <div className='form-item'>
                <label className='form-label'>
                  รหัสผ่านเข้าสู่ระบบปัจจุบัน
                </label>

                <div className='form-content'>
                  <input
                    type='password'
                    className='form-input'
                    value={oldPassword}
                    onChange={(e) =>
                      setOldPassword(e.target.value)
                    }
                  />
                </div>
              </div>

              <div className='form-item'>
                <label className='form-label'>
                  รหัสผ่านใหม่
                </label>

                <div className='form-content'>
                  <input
                    type='password'
                    className='form-input'
                    value={newPassword}
                    onChange={(e) =>
                      setNewPassword(e.target.value)
                    }
                  />
                </div>
              </div>

              <div className='form-item'>
                <label className='form-label'>
                  ยืนยันรหัสผ่าน
                </label>

                <div className='form-content'>
                  <input
                    type='password'
                    className='form-input'
                    value={confirmPassword}
                    onChange={(e) =>
                      setConfirmPassword(e.target.value)
                    }
                  />
                </div>
              </div>

              <div className='form-actions'>
                <button
                  type='submit'
                  className='btn primary'
                >
                  เปลี่ยนรหัสผ่าน
                </button>

                <button
                  type='button'
                  className='btn info'
                  onClick={() => {
                    setOldPassword('')
                    setNewPassword('')
                    setConfirmPassword('')
                  }}
                >
                  รีเซ็ต
                </button>
              </div>
            </form>
          </div>
        )}

        {activeTab === 'change-withdraw-password' && (
          <ThayDoiPassBank />
        )}
      </div>

      {message && (
        <Notify
          message={message}
          type={typenoti}
          setcontent={setMessage}
        />
      )}

      <Loading isLoading={loading} />
    </>
  )
}

export default PersonalTabs